import PoliciesTable from "./PoliciesTable";

export default function MyPolicies() {
  return <PoliciesTable variant="page" />;
}
